@use "../../../../globals/bcp";
@use "../../../../globals/bcp-2022/old-mixins/media" as *;

bcp-duplication-entry-modal {
  .duplication-modal {
    &__action-buttons-container {
      display: flex;
      gap: bcp.size(8);

      @include media(mobile) {
        flex-direction: column;
      }
    }
  }
}
